import React, {Component} from 'react';
import styles from './SearchBar.css';

import {Button, Form, FormGroup, Label, Input} from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';

import 'moment/locale/de'

import {color_orange} from "../../constants/colors";

export default class SearchBar extends Component {
    constructor(props) {

        super(props);

        this.state = {
            what: "",
            where: "",
            when: "",
            allowedDocs: [],
            whatError: false,
            whereError: false,
            whenError: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        const {searchQuery} = this.props;

        this.setState({
            what: searchQuery.what,
            where: searchQuery.where,
            when: searchQuery.when,
            allowedDocs: searchQuery.allowedDocs,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchQuery.what !== this.props.searchQuery.what) {
            this.setState({
                what: this.props.searchQuery.what
            });
        }

        if (prevProps.searchQuery.where !== this.props.searchQuery.where) {
            this.setState({
                where: this.props.searchQuery.where
            });
        }

        if (prevProps.searchQuery.when !== this.props.searchQuery.when) {
            this.setState({
                when: this.props.searchQuery.when
            });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(name === "doc") {
            if(value === null) {
                return this.setState({
                    what: "",
                    allowedDocs: [],
                });
            }

            const docObject = JSON.parse(value);
            this.setState({
                what: docObject.doctorGroupID,
                allowedDocs: [docObject.doctorID],
            });

            return;
        }

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const {where, when} = this.state;
        let {what, allowedDocs} = this.state;
        const {handleSearchSubmit, iframe, iframeDocs} = this.props;

        let whatError, whereError, whenError;
        whatError = whereError = whenError = false;

        if ((what === '' || what === undefined)) {
            whatError = true;
        }

        if (where === '') {
            whereError = true;
        }

        if (when === '' || when === undefined) {
            whenError = true;
        }

        this.setState({
            whatError: whatError,
            whereError: whereError,
            whenError: whenError,
        });

        if (what === undefined || what === '' || where === '' || when === '') return;

        const searchQuery = {
            what,
            where,
            when,
            allowedDocs,
        };

        handleSearchSubmit(searchQuery);
    }

    render() {
        const {fachgruppen, iframe, iframeDocs} = this.props;
        const {what, where, when, whatError, whenError, whereError, allowedDocs} = this.state;

        let date = null;
        if (when) {
            date = new Date(parseInt(when));
        }

        if(iframe) {
            return (
                <Form inline action="/search" className={["form", styles.form, styles.inline].join(' ')} onSubmit={this.handleFormSubmit}>
                    
                    <FormGroup
                        className={[styles.inputWhat, styles.formGroup, whatError ? styles.error : ""].join(' ')}>
                        <select name="doc" id="doc" onChange={this.handleInputChange}>
                        <option value={JSON.stringify(null)}>Behandler wählen</option>
                            {
                                iframeDocs.map(value => {
                                    let selected = false;
                                    if (allowedDocs.indexOf(value.doctorID) > -1) {
                                        selected = true;
                                    }
                                    return (
                                        <option value={JSON.stringify(value)} selected={selected}>{value.name}</option>
                                    )
                                })
                            }
                        </select>

                    </FormGroup>

                    <FormGroup
                        className={[styles.inputWhen, styles.formGroup, whenError ? styles.error : ""].join(' ')}>


                        <DayPickerInput className={styles.lastInput}
                                        placeholder="Datum wählen"
                                        value={date}
                                        onDayChange={day => {
                                            this.setState({
                                                when: day.getTime()
                                            });
                                        }}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        dayPickerProps={{
                                            locale: 'de',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                        />
                    </FormGroup>

                    <Button type="submit" style={{background: color_orange}}
                            onClick={(event) => this.handleFormSubmit(event)}>Termine suchen</Button>

            </Form>
            )
        }

        return (
            <Form inline action="/search" className={styles.form} onSubmit={this.handleFormSubmit}>

                <div className={styles.flexWrapper}>

                    <FormGroup
                        className={[styles.inputWhat, styles.formGroup, whatError ? styles.error : ""].join(' ')}>
                        <select name="what" id="was" onChange={this.handleInputChange}>
                            <option value="">Was?</option>
                            {
                                fachgruppen.map(value => {
                                    let selected = false;
                                    if (parseInt(what) === value.id) {
                                        selected = true;
                                    }
                                    return (
                                        <option value={value.id} selected={selected}>{value.singular}</option>
                                    )
                                })
                            }
                        </select>

                    </FormGroup>

                    <FormGroup
                        className={[styles.inputWhere, styles.formGroup, whereError ? styles.error : ""].join(' ')}>
                        <Input type="text" name="where" id="wo" placeholder="Wo?" autocomplete="off" value={where}
                            onChange={this.handleInputChange}/>
                    </FormGroup>

                </div>

                <div className={styles.flexWrapper}>

                    <FormGroup
                        className={[styles.inputWhen, styles.formGroup, whenError ? styles.error : ""].join(' ')}>


                        <DayPickerInput className={styles.lastInput}
                                        placeholder="Wann?"
                                        value={date}
                                        onDayChange={day => {
                                            this.setState({
                                                when: day.getTime()
                                            });
                                        }}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        dayPickerProps={{
                                            locale: 'de',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                        />
                    </FormGroup>

                    <Button type="submit" style={{background: color_orange}}
                            onClick={(event) => this.handleFormSubmit(event)}>Termine suchen</Button>

                </div>
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js